const configs = {
  APP_ENV: process.env.VUE_APP_ENV,
  API_DOMAIN: process.env.VUE_APP_API_DOMAIN,
  WEB_DOMAIN: window.origin,
};

export default configs;
